export default {
  adminSetupModules (state) {
    return state.adminSetupModules.filter(mod =>
      mod.title.toLowerCase().includes(state.modulesSearchQuery.toLowerCase())
    )
  }
}
